import PageRequest from '../../../../../../pagination-helper/lib/PageRequest';

/**
 * * Модель запроса на получение списка истории изменений задачи
 */
export default class GetActionHistoryListRequest  {
	/**
	 * * Пагинация
	 */
	Page!: PageRequest;
	/**
	 * * Номер задачи
	 */
	TaskId!: number;
	constructor(obj?: Partial<GetActionHistoryListRequest>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
